import React from 'react';
import Button from '../common/Button';

/**
 * Competitive session Player Ranking tab: categorisation overview and ranking sections.
 * renderRankingSection(section) is called by the parent to render each section's content.
 */
function PlayerRankingTab({
  categorizationEnabled,
  categoryStatusText,
  lastCategoryCalculation,
  formatRelativeCategoryTime,
  categorySummaryText,
  handleCategorizationToggle,
  handleManualCategoryRefresh,
  isCategoryRefreshing,
  rankingTabOptions,
  rankingTab,
  setRankingTab,
  currentRankingSection,
  renderRankingSection,
}) {
  return (
    <div className="mt-6 space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Player Categorisation Overview</h3>
          <p className="text-sm text-text-secondary">{categoryStatusText}</p>
          {lastCategoryCalculation && categorizationEnabled && (
            <p className="text-xs text-text-muted">
              Last calculated {formatRelativeCategoryTime(lastCategoryCalculation)}
            </p>
          )}
          {categorizationEnabled && categorySummaryText && (
            <p className="text-xs text-text-muted mt-1">{categorySummaryText}</p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={handleCategorizationToggle}
            className={`px-3 py-1.5 rounded-md text-sm font-medium border transition ${
              categorizationEnabled
                ? 'bg-green-100 text-green-800 border-green-300'
                : 'bg-gray-100 text-gray-700 border-gray-300'
            }`}
          >
            {categorizationEnabled ? 'Categorisation On' : 'Categorisation Off'}
          </button>
          <Button
            variant="secondary"
            onClick={handleManualCategoryRefresh}
            disabled={!categorizationEnabled || isCategoryRefreshing}
          >
            {isCategoryRefreshing ? 'Refreshing...' : 'Refresh'}
          </Button>
        </div>
      </div>

      {!categorizationEnabled ? (
        <div className="p-4 border border-dashed border-border-medium rounded-lg text-sm text-text-secondary bg-surface">
          Enable player categorisation to view live category assignments.
        </div>
      ) : (
        <div className="space-y-5">
          <div className="flex flex-wrap gap-2">
            {rankingTabOptions.map((option) => (
              <button
                key={option.key}
                type="button"
                onClick={() => setRankingTab(option.key)}
                className={`px-3 py-1.5 rounded-full text-sm font-medium border transition ${
                  rankingTab === option.key
                    ? 'bg-primary text-text-inverse border-primary'
                    : 'bg-surface-subtle text-text-primary border-border-medium hover:bg-surface'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
          {currentRankingSection ? (
            renderRankingSection(currentRankingSection)
          ) : (
            <div className="p-4 border border-dashed border-border-medium rounded-lg text-sm text-text-secondary bg-surface">
              No ranking data available.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default PlayerRankingTab;
